import { render, staticRenderFns } from "./RegoSearchLookup.vue?vue&type=template&id=4e553deb&scoped=true&"
import script from "./RegoSearchLookup.vue?vue&type=script&lang=ts&"
export * from "./RegoSearchLookup.vue?vue&type=script&lang=ts&"
import style0 from "./RegoSearchLookup.vue?vue&type=style&index=0&id=4e553deb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e553deb",
  null
  
)

export default component.exports